import { ISelectionContext } from './ISelectionContext'
export default class CheckBoxSelectionContext implements ISelectionContext {
  constructor(public selectedColumn: number) {}
}
